// extracted by mini-css-extract-plugin
export default {"adVideo":"style_adVideo_-J0ud","adImg":"style_adImg_H33dK","adIframe":"style_adIframe_5GWwD","adIframeContent":"style_adIframeContent_jMvGg"};